module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "f9")) { return null; }
        _vm.compile($event)
      }
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-inverse navbar-sm"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "user-secret"
    }
  }), _vm._v(" " + _vm._s(_vm.agentType.name) + " (" + _vm._s(_vm.agentType.agentNames.length) + ")")], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['f9']),
      expression: "['f9']"
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.compile,
      "shortkey": function($event) {
        _vm.compile()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "gears"
    }
  }), _vm._v(" Compile")], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [(_vm.activeAgent) ? _c('li', {
    class: {
      active: _vm.rightPanel == 'CALLSTACK'
    },
    on: {
      "click": function($event) {
        _vm.toggleRightPanel('CALLSTACK')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "stack-overflow"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.activeAgent) ? _c('li', {
    class: {
      active: _vm.rightPanel == 'MEMORY'
    },
    on: {
      "click": function($event) {
        _vm.toggleRightPanel('MEMORY')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "database"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.agentType.instructions) ? _c('li', {
    class: {
      active: _vm.rightPanel == 'INSTRUCTIONS'
    },
    on: {
      "click": function($event) {
        _vm.toggleRightPanel('INSTRUCTIONS')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "th-list"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      active: _vm.rightPanel == 'CONSOLE'
    },
    on: {
      "click": function($event) {
        _vm.toggleRightPanel('CONSOLE')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "list-alt"
    }
  })], 1)]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.rightPanel == 'API'
    },
    on: {
      "click": function($event) {
        _vm.toggleRightPanel('API')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "book"
    }
  }), _vm._v(" Help")], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "agent-bar"
  }, _vm._l((_vm.agentType.agentNames), function(agentName) {
    return _c('span', {
      class: {
        active: _vm.activeAgent && _vm.activeAgent.name == agentName
      },
      on: {
        "click": function($event) {
          _vm.agentNameClick(agentName)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "user-secret"
      }
    }), _vm._v(" " + _vm._s(agentName))], 1)
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden",
      "position": "relative"
    }
  }, [_c('aceEditor', {
    ref: "aceEditor",
    attrs: {
      "width": "100%",
      "height": "200px",
      "initialSource": _vm.agentType.definition.solution
    },
    on: {
      "change": _vm.editorChange,
      "gutterClick": _vm.toggleBreakpoint
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rightPanel != null),
      expression: "rightPanel != null"
    }],
    staticClass: "right-panel"
  }, [(_vm.rightPanel == 'INSTRUCTIONS') ? _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.agentType.instructions), function(instruction, index) {
    return _c('tr', {
      class: {
        info: _vm.selectedInstruction == instruction, warning: instruction.breakpoint
      },
      on: {
        "click": function($event) {
          _vm.selectInstruction(instruction)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(index))]), _c('td', [_vm._v(_vm._s(instruction.id))]), _c('td', [_vm._v(_vm._s(instruction.params))])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.agentType.definition.api) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rightPanel == 'API'),
      expression: "rightPanel=='API'"
    }],
    staticClass: "doc-panel"
  }, [_c('tabs', {
    attrs: {
      "nav-style": "pills"
    }
  }, _vm._l((_vm.agentType.definition.api), function(api) {
    return _c('tab', {
      attrs: {
        "header": api.name
      }
    }, [_c('resourceTemplate', {
      attrs: {
        "resource": api.doc
      }
    })], 1)
  }))], 1) : _vm._e(), _vm._v(" "), _c('console', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rightPanel == 'CONSOLE'),
      expression: "rightPanel=='CONSOLE'"
    }],
    attrs: {
      "keys": _vm.agentType.agentNames,
      "slim": "true"
    }
  }), _vm._v(" "), (_vm.activeAgent && _vm.rightPanel == 'CALLSTACK') ? _c('div', [_c('h4', [_vm._v("Call stack")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-condensed"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.activeAgent.executor.memory.callStack.array), function(instruction, index) {
    return _c('tr', {
      class: {
        info: _vm.selectedInstruction == instruction, warning: instruction.breakpoint
      },
      on: {
        "click": function($event) {
          _vm.selectInstruction(instruction)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(index))]), _c('td', [_vm._v(_vm._s(instruction.params.name))])])
  }))]), _vm._v(" "), _c('h4', [_vm._v("Main value stack")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-condensed"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.activeAgent.executor.stack.array), function(value, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index))]), _c('td', [_c('objectView', {
      attrs: {
        "value": _vm.activeAgent.executor.stack.array[index]
      }
    })], 1)])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.activeAgent && _vm.rightPanel == 'MEMORY') ? _c('div', [_c('h3', [_vm._v("Global scope")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-condensed"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((Object.keys(_vm.activeAgent.executor.memory.globalScope())), function(key) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(key))]), _c('td', [_c('objectView', {
      attrs: {
        "value": _vm.activeAgent.executor.memory.loadGlobal(key)
      }
    }), _vm._v(" }}")], 1)])
  }))]), _vm._v(" "), _c('h3', [_vm._v("Local scope")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-condensed"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((Object.keys(_vm.activeAgent.executor.memory.localScope())), function(key) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(key))]), _c('td', [_c('objectView', {
      attrs: {
        "value": _vm.activeAgent.executor.memory.loadLocal(key)
      }
    })], 1)])
  }))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "status-bar"
  }, [_c('icon', {
    attrs: {
      "name": _vm.agentType.state.icon
    }
  }), _vm._v(" " + _vm._s(_vm.agentType.state.message) + "\n  ")], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _c('th', [_vm._v("Instruction")]), _c('th', [_vm._v("Parameters")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _c('th', [_vm._v("Function call")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _c('th', [_vm._v("Value")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Identifier")]), _c('th', [_vm._v("Value")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Identifier")]), _c('th', [_vm._v("Value")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b366a3d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workbench/editor/Codearea.vue
// module id = 1549
// module chunks = 2